<template>

    <div>

        <v-row align="center" justify="center">
            <v-overlay color="White" :absolute="absolute" :value="overlay">

                <div class="text-center">
                    <v-progress-circular :size="70" :width="7" color="blue" indeterminate></v-progress-circular>
                </div>

            </v-overlay>
        </v-row>





        <v-subheader>
            <v-btn color="primary" @click="isHome">
                <v-icon>mdi-home</v-icon>
                Home
            </v-btn>
        </v-subheader>
        <div v-if="countCart > 0">
            <v-card flat>
                <v-list three-line v-if="countCart > 0">
                    <template v-for="(item, index) in carts">
                        <v-list-item :key="'cart' + index">
                            <v-list-item-avatar>
                                <v-img :src="getImage('/' + item.cover)"></v-img>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title v-html="item.title"></v-list-item-title>
                                <v-list-item-subtitle>
                                    Rp. {{ item.price.toLocaleString('id-ID') }}
                                    ({{ item.weight }} gr)
                                    <span style="float:right">
                                        {{ item.quantity }}
                                    </span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list>
                <v-container>
                    <v-card-actions>
                        Subtotal
                        <v-spacer />
                        Rp. {{ totalPrice.toLocaleString('id-ID') }}
                    </v-card-actions>
                </v-container>
            </v-card>
        </div>
        <div v-if="countCart > 0">
            <v-card flat>
                <v-container>

                    <v-card-actions>
                        Platform
                        <v-spacer />
                        <v-col class="d-flex" cols="12" sm="6">
                            <v-select :items="items" label="Standard"></v-select>
                        </v-col>
                    </v-card-actions>

                    <v-card-actions>
                        Service Fee rate*
                        <v-spacer />
                        <v-col class="d-flex" cols="12" sm="6">
                            <v-text-field label="service free rate" v-model="serviceFree" required
                                @input="calculateServiceFee" @keypress="filter(event)"></v-text-field>
                            %
                        </v-col>
                    </v-card-actions>

                    <v-card-actions>
                        Promo Rate*
                        <v-spacer />
                        <v-col class="d-flex" cols="12" sm="6">
                            <v-text-field label="promo rate" v-model="promoRate" required @input="calculateServiceFee"
                                @keypress="filter(event)">
                            </v-text-field>
                            %
                        </v-col>
                    </v-card-actions>
                </v-container>
            </v-card>
        </div>





        <v-subheader>Total</v-subheader>
        <v-card>
            <v-container>
                <v-layout row wrap>
                    <v-flex xs6 text-center>
                        Total Bill ({{ totalQuantity }} items)
                        <div class="title">{{ totalBill.toLocaleString('id-ID') }}</div>
                    </v-flex>
                    <v-flex xs6 text-center>
                        <!-- :disabled="totalBill==0" -->
                        <v-btn color="orange" @click="dialogConfirm = true">
                            <v-icon light>mdi-cash</v-icon> &nbsp;
                            Pay
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
        <br>
        <template>
            <v-layout row justify-center>

                <v-dialog v-model="dialogConfirm" persistent max-width="600">
                    <v-card>
                        <v-flex xs6 text-center>
                            <div class="title">Pilih Nominal Pembayaran</div>
                        </v-flex>
                        <v-item-group v-model="selected" multiple>
                            <v-row>
                                <v-col v-for="(item, i) in list_images" :key="i" cols="12" md="4">
                                    <v-item v-slot="{ active, toggle }">
                                        <v-img :src="getImage('/' + item.image_url)" height="150"
                                            class="text-right pa-2" @click="toggle">
                                            <v-btn icon dark>
                                                <v-icon>
                                                    {{ active ? 'mdi-checkbox-marked-circle' : 'mdi-checkbox-marked-circle-outline' }}
                                                </v-icon>
                                            </v-btn>
                                        </v-img>
                                    </v-item>
                                </v-col>
                            </v-row>
                        </v-item-group>

                        <v-text-field v-model="nominalOther" @keypress="filter(event)" label="Nominal Lain">
                        </v-text-field>

                        <v-card-actions>
                            <v-btn color="warning" @click="cancel">Cancel</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click="pay">Continue</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </template>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    data() {
        return {
            name_order: '',
            address: '',
            phone: '',
            province_id: 10,
            city_id: 0,
            subdistrict_id: 0,
            courier: '',
            couriers: [],
            service: '',
            services: [],
            shippingCost: 0,
            totalBill: 0,
            dialogConfirm: false,
            absolute: true,
            overlay: false,
            items: ['Tokopedia', 'Shoopi'],
            serviceFree: 0,
            promoRate: 0,
            totalFree: 0,
            list_images: [],
            selected: [],
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            provinces: 'region/provinces',
            cities: 'region/cities',
            subdistrict: 'region/subdistrict',
            // tambahkan ini
            carts: 'cart/carts',
            countCart: 'cart/count',
            totalPrice: 'cart/totalPrice',
            totalQuantity: 'cart/totalQuantity',
            totalWeight: 'cart/totalWeight',
        }),
        citiesByProvince() {
            let province_id = this.province_id
            return this.cities.filter((city) => {
                if (city.province_id == province_id) return city
            })
        },
        subdistrictByCities() {
            let city_id = this.city_id
            this.selectSubdistrict()
            return this.subdistrict.filter((subdistrict) => {
                if (subdistrict.city_id == city_id) return subdistrict
            })
        },

    },
    methods: {
        ...mapActions({
            setAlert: 'alert/set',
            setAuth: 'auth/set',
            setProvinces: 'region/setProvinces',
            setCities: 'region/setCities',
            setSubdistrict: 'region/setSubdistrict',
            setCart: 'cart/set',
            setPayment: 'setPayment'
        }),
        selectSubdistrict() {
            if (this.city_id != 0) {
                let city_id = this.city_id
                this.axios.get('/subdistrict?cities_id=' + parseInt(city_id))
                    .then((response) => {
                        let { data } = response.data
                        this.setSubdistrict(data)
                    })
            }
        },
        saveShipping() {
            this.overlay = true
            let formData = new FormData()
            formData.set('name_order', this.name_order)
            formData.set('address', this.address)
            formData.set('phone', this.phone)
            formData.set('province_id', this.province_id)
            formData.set('city_id', this.city_id)
            formData.set('subdistrict_id', this.subdistrict_id)
            if (this.subdistrict_id == null) {
                this.setAlert({
                    status: true,
                    text: 'Subdistrict ​​must be selected',
                    color: 'warning',
                })
            }
            if (this.city_id == null) {
                this.setAlert({
                    status: true,
                    text: 'City ​​must be selected',
                    color: 'warning',
                })
            }
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + this.user.api_token,
                },
            }

            this.axios.post('/shipping', formData, config)
                .then((response) => {
                    let { data } = response
                    this.setAuth(data.data)
                    this.setAlert({
                        status: true,
                        text: data.message,
                        color: 'success',
                    })
                    this.overlay = false
                })
                .catch((error) => {
                    this.overlay = false
                    let { data } = error
                    this.setAlert({
                        status: true,
                        text: data.message,
                        color: 'error',
                    })
                })
        },
        getServices() {
            this.overlay = true
            let courier = this.courier
            let encodedCart = JSON.stringify(this.carts)
            //console.log(encodedCart)
            let formData = new FormData()
            formData.set('courier', courier)
            formData.set('carts', encodedCart);

            let config = {
                headers: {
                    'Authorization': 'Bearer ' + this.user.api_token,
                },
            }
            this.axios.post('/services', formData, config)
                .then((response) => {
                    let response_data = response.data
                    // jika tidak error maka data service dan cart akan diupdate.
                    if (response_data.status != 'error') {
                        this.services = response_data.data.services
                        this.setCart(response_data.data.safe_carts)
                        this.overlay = false
                    }

                    this.setAlert({
                        status: true,
                        text: response_data.message,
                        color: response_data.status,
                    })
                })
                .catch((error) => {
                    this.overlay = false
                    let responses = error.response
                    this.setAlert({
                        status: true,
                        text: responses.data.message,
                        color: 'error',
                    })
                })
        },
        calculateServiceFee() {
            this.totalFree = parseFloat(this.serviceFree) + parseFloat(this.promoRate);
            this.calculateBill();
        },
        calculateBill() {
            // let selectedService = this.services.find((service) => {
            //     return (service.service==this.service)
            // })
            // this.shippingCost = selectedService.cost
            // this.totalBill = parseInt(this.totalPrice) + parseInt(this.shippingCost)
            this.totalBill = parseFloat(this.totalPrice) - (this.totalFree / 100)
        },
        pay() {
            this.overlay = true
            this.dialogConfirm = false
            let courier = this.courier
            let service = this.service
            let safeCart = JSON.stringify(this.carts)
            let formData = new FormData()
            formData.set('courier', courier)
            formData.set('service', service)
            formData.set('carts', safeCart);
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + this.user.api_token,
                },
            }
            this.axios.post('/payment', formData, config)
                .then((response) => {
                    let { data } = response
                    if (data && data.status == 'success') {
                        this.setPayment(data.data) // <= ini
                        this.$router.push({ path: "/payment" })
                        this.setCart([])
                        this.overlay = false
                    }
                    this.overlay = false
                    this.setAlert({

                        status: true,
                        text: data.message,
                        color: data.status,
                    })
                })
                .catch((error) => {
                    this.overlay = false
                    let { data } = error.response
                    this.setAlert({
                        status: true,
                        text: data.message,
                        color: 'error',
                    })
                })
        },
        cancel() {
            this.dialogConfirm = false
        },
        isHome() {

            return this.$router.push({ path: "/" })

        },
        filter: function (evt) {
            evt = (evt) ? evt : window.event;
            let expect = evt.target.value.toString() + evt.key.toString();

            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    },
    created() {
        this.name_order = this.user.name_order
        this.address = this.user.address
        this.phone = this.user.phone
        this.subdistrict_id = this.user.subdistrict_id
        this.city_id = this.user.city_id
        this.province_id = this.user.province_id

        if (this.provinces && this.provinces.length == 0) {
            this.axios.get('/provinces')
                .then((response) => {
                    let { data } = response.data
                    this.setProvinces(data)
                    //console.log(data);

                })

            this.axios.get('/cities')
                .then((response) => {
                    let { data } = response.data
                    this.setCities(data)
                })

            this.axios.get('/subdistrict')
                .then((response) => {
                    let { data } = response.data
                    this.setSubdistrict(data)
                })
        }



        if (this.couriers.length == 0) {
            this.axios.get('/couriers')
                .then((response) => {
                    this.couriers = response.data.data
                })
        }

        this.calculateBill()

        this.axios
            .get("/commonImage/slider")
            .then((response) => {
                let { data } = response.data;
                this.list_images = data;
            })
            .catch((error) => {
                let { responses } = error;
                console.log(responses);
            });
    }
}
</script>
<style scoped>
.v-progress-circular {
    margin: 1rem;
}
</style>